"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactCountdownCircleTimer = require("react-countdown-circle-timer");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _hooks = require("../../hooks");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const renderTime = _ref => {
  let {
    remainingTime
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-center flex-column"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "m-0 color-main-color-primary"
  }, remainingTime, " sec"), /*#__PURE__*/_react.default.createElement("span", {
    className: "span-little fw-normal",
    style: {
      color: 'var(--main-color-cl-15)'
    }
  }, "remains"));
};
const FlushingCircle = _ref2 => {
  let {
    thingPDIDDevice
  } = _ref2;
  const [isPlaying, setIsPlaying] = (0, _react.useState)(true);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    value: duration
  } = (0, _hooks.useGetValueByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.durationRegex
  });
  const onCompleteFlush = (0, _react.useCallback)(() => {
    setIsPlaying(false);
    return {
      shouldRepeat: false
    };
  }, [dispatch]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "opacity-0 position-absolute pointer-event-none"
  }, /*#__PURE__*/_react.default.createElement("svg", null, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "countdown-gradient",
    x1: "1",
    y1: "0",
    x2: "0",
    y2: "0",
    gradientTransform: "rotate(-25)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: "#0000FF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: "#1CE783"
  }))))), /*#__PURE__*/_react.default.createElement(_reactCountdownCircleTimer.CountdownCircleTimer, {
    isPlaying: isPlaying,
    size: 160,
    strokeWidth: 6.75,
    duration: duration,
    isGrowing: true,
    rotation: "counterclockwise",
    initialRemainingTime: duration,
    trailColor: "var(--main-color-cl-19)",
    colors: "url(#countdown-gradient)",
    onComplete: onCompleteFlush
  }, renderTime)), [duration, onCompleteFlush, isPlaying]);
};
var _default = exports.default = FlushingCircle;